import React from "react";
import DelegateButton from "@components/FlowActionButtons/DelegateButton";

interface DelegateMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
}

const LANG_BASE = "vessel-call.movement-services";

const DelegateMovement: React.FC<DelegateMovementProps> = ({ movementFlowData }) => {
  if (!movementFlowData) {
    return null;
  }

  if (!movementFlowData.task) {
    return null;
  }

  const isActionAvailable = false; // this is to be refined
  const handleDelegateClick = () => {};

  return (
    <DelegateButton
      langBase={LANG_BASE}
      permission="canDelegateMovementService"
      isActionAvailable={isActionAvailable}
      onDelegate={handleDelegateClick}
    />
  );
};
export default DelegateMovement;
